// material-ui
import { styled } from '@mui/material/styles';
import Drawer from '@mui/material/Drawer';

// project imports
import { DRAWER_WIDTH } from 'config';

const openedMixin = (theme) => ({
  width: DRAWER_WIDTH,
  borderRight: '1px solid',
  borderRightColor: theme.vars.palette.divider,
  transition: 'none',
  willChange: 'initial',
  overflowX: 'hidden',
  boxShadow: 'none !important',

  // Logo transitions
  '& .logo-icon': {
    display: 'none !important'
  },
  '& .logo-main': {
    display: 'flex !important'
  },

  // Navigation Group layout
  '& .MuiList-root': {
    marginBottom: `${theme.spacing(1.5)} !important`,
    paddingTop: 0,
    paddingBottom: 0
  },

  // Nav group header
  '& .nav-group-header': {
    paddingLeft: `${theme.spacing(1.5)} !important`,
    paddingRight: `${theme.spacing(1.5)} !important`,
    marginBottom: `${theme.spacing(0.5)} !important`,
    paddingTop: `${theme.spacing(0.5)} !important`,
    paddingBottom: `${theme.spacing(0.5)} !important`,
    marginLeft: `${theme.spacing(1)} !important`,
    marginRight: `${theme.spacing(1)} !important`,
    justifyContent: 'space-between !important',
    cursor: 'pointer !important',
    backgroundColor: 'transparent !important',
    '&:hover': {
      backgroundColor: `${theme.vars.palette.action.hover} !important`
    },
    '&.Mui-selected': {
      backgroundColor: 'transparent !important'
    }
  },
  '& .nav-group-icon': {
    display: 'flex !important',
    minWidth: '28px !important',
    width: '28px !important',
    height: '28px !important',
    alignItems: 'center !important',
    justifyContent: 'center !important',
    color: `${theme.palette.primary.main} !important`,
    backgroundColor: 'transparent !important',
    boxShadow: 'none !important',
    border: 'none !important',
    outline: 'none !important'
  },
  '& .nav-group-title-container': {
    display: 'flex !important'
  },
  '& .nav-group-collapse-container': {
    display: 'block !important'
  },

  // Navigation Item layout when drawer is open
  '& .MuiListItemButton-root': {
    '&[data-level="1"]': {
      paddingLeft: '12px !important'
    },
    '&[data-level="2"]': {
      paddingLeft: '44px !important'
    },
    paddingTop: `${theme.spacing(0.75)} !important`,
    paddingBottom: `${theme.spacing(0.75)} !important`
  },

  // Item icon
  '& .MuiListItemIcon-root': {
    fontSize: '1.25rem !important',
    minWidth: '28px !important',
    width: '28px !important',
    height: '28px !important',
    alignItems: 'center !important',
    justifyContent: 'center !important',
    backgroundColor: 'transparent !important',
    color: `${theme.palette.primary.main} !important`,
    marginRight: '10px !important',
    boxShadow: 'none !important',
    border: 'none !important',
    outline: 'none !important',
    '& svg': {
      fontSize: '1.25rem !important',
      color: `${theme.palette.primary.main} !important`
    },
    '&[data-parents="true"] svg': {
      fontSize: '1.25rem !important',
      color: `${theme.palette.primary.main} !important`
    }
  },

  // Item text
  '& .MuiListItemText-root': {
    opacity: '1 !important',
    width: 'auto !important',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    transition: 'none !important'
  },

  // Chip
  '& .MuiChip-root': {
    opacity: '1 !important',
    transform: 'scale(1) !important',
    width: 'auto !important',
    transition: 'none !important'
  },

  // Actions
  '& .nav-item-action': {
    opacity: '1 !important',
    pointerEvents: 'auto !important',
    transition: 'none !important'
  }
});

const closedMixin = (theme) => ({
  transition: 'none',
  willChange: 'initial',
  overflowX: 'hidden',
  width: theme.spacing(7.5),
  borderRight: 'none',
  boxShadow: 'none',

  // Logo transitions
  '& .logo-icon': {
    display: 'flex !important'
  },
  '& .logo-main': {
    display: 'none !important'
  },

  // Navigation Group layout
  '& .MuiList-root': {
    marginBottom: '0px !important',
    paddingTop: 0,
    paddingBottom: 0
  },

  // Nav group header
  '& .nav-group-header': {
    paddingLeft: `${theme.spacing(1.5)} !important`,
    paddingRight: `${theme.spacing(1.5)} !important`,
    marginBottom: '0px !important',
    paddingTop: `${theme.spacing(1.25)} !important`,
    paddingBottom: `${theme.spacing(1.25)} !important`,
    marginLeft: '0px !important',
    marginRight: '0px !important',
    justifyContent: 'center !important',
    cursor: 'pointer !important',
    backgroundColor: 'transparent !important',
    '&:hover': {
      backgroundColor: 'transparent !important'
    }
  },
  '& .nav-group-header:hover .nav-group-icon': {
    backgroundColor: `${theme.vars.palette.action.hover} !important`,
    color: `${theme.vars.palette.text.primary} !important`
  },
  '& .nav-group-icon': {
    display: 'flex !important',
    width: '28px !important',
    height: '28px !important',
    minWidth: '28px !important',
    alignItems: 'center !important',
    justifyContent: 'center !important',
    color: `${theme.palette.primary.main} !important`,
    backgroundColor: 'transparent !important',
    '& svg': {
      fontSize: '1.25rem !important',
      color: `${theme.palette.primary.main} !important`
    }
  },
  '& .nav-group-title-container': {
    display: 'none !important'
  },
  '& .nav-group-collapse-container': {
    display: 'none !important'
  },

  // Navigation Item layout when drawer is closed
  '& .MuiListItemButton-root': {
    paddingLeft: `${theme.spacing(1.5)} !important`,
    paddingTop: `${theme.spacing(1.25)} !important`,
    paddingBottom: `${theme.spacing(1.25)} !important`,
    backgroundColor: 'transparent !important',
    '&:hover': {
      backgroundColor: 'transparent !important'
    },
    '&.Mui-selected': {
      backgroundColor: 'transparent !important',
      borderRight: 'none !important',
      color: `${theme.palette.primary.main} !important`,
      '&:hover': {
        backgroundColor: 'transparent !important'
      }
    }
  },

  // Item icon
  '& .MuiListItemIcon-root': {
    fontSize: '1.25rem !important',
    minWidth: '28px !important',
    width: '28px !important',
    height: '28px !important',
    alignItems: 'center !important',
    justifyContent: 'center !important',
    marginLeft: 'auto !important',
    marginRight: 'auto !important',
    backgroundColor: 'transparent !important',
    color: `${theme.palette.primary.main} !important`,
    transition: 'background-color 150ms ease-in-out',
    '& svg': {
      fontSize: '1.25rem !important',
      color: `${theme.palette.primary.main} !important`
    },
    '&:hover': {
      backgroundColor: 'transparent !important',
      color: `${theme.palette.primary.main} !important`
    }
  },
  '& .MuiListItemButton-root.Mui-selected .MuiListItemIcon-root': {
    backgroundColor: 'transparent !important',
    color: `${theme.palette.primary.main} !important`,
    '&:hover': {
      backgroundColor: 'transparent !important'
    }
  },

  // Item text
  '& .MuiListItemText-root': {
    opacity: '0 !important',
    width: '0 !important',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    transition: 'none !important'
  },

  // Chip
  '& .MuiChip-root': {
    opacity: '0 !important',
    transform: 'scale(0) !important',
    width: '0 !important',
    transition: 'none !important'
  },

  // Actions
  '& .nav-item-action': {
    opacity: '0 !important',
    pointerEvents: 'none !important',
    transition: 'none !important'
  }
});

// ==============================|| DRAWER - MINI STYLED ||============================== //

const MiniDrawerStyled = styled(Drawer, { shouldForwardProp: (prop) => prop !== 'open' })(({ theme }) => ({
  width: DRAWER_WIDTH,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  variants: [
    {
      props: ({ open }) => open,
      style: { ...openedMixin(theme), '& .MuiDrawer-paper': openedMixin(theme) }
    },
    {
      props: ({ open }) => !open,
      style: { ...closedMixin(theme), '& .MuiDrawer-paper': closedMixin(theme) }
    }
  ]
}));

export default MiniDrawerStyled;

